import type { JsonLd } from './seo';

const MARKER = 'data-route-jsonld';

export function injectJsonLd(data: JsonLd[]): void {
  clearJsonLd();
  data.forEach((item) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(MARKER, 'true');
    script.textContent = JSON.stringify(item);
    document.head.appendChild(script);
  });
}

export function clearJsonLd(): void {
  document
    .querySelectorAll(`script[${MARKER}]`)
    .forEach((el) => el.remove());
}